import * as React from 'react'
import { Text, TouchableOpacity, Linking } from 'react-native'
import styled from '@theme/styled-components'

import useI18n from '@i18n/useI18n'

import { LINKS } from '@app/config'

interface Props {
  alignTextLeft?: boolean
}

const CGU = ({ alignTextLeft = false }: Props) => {
  const i18n = useI18n()

  return (
    <>
      <UsefullLink onPress={() => Linking.openURL(LINKS.cgu.replace('{{lang}}', i18n.lang))}>
        <LinkText alignTextLeft={alignTextLeft}>{i18n.t('screens.login.links.cgu')}</LinkText>
      </UsefullLink>
      <UsefullLink onPress={() => Linking.openURL(LINKS.cookies.replace('{{lang}}', i18n.lang))}>
        <LinkText alignTextLeft={alignTextLeft}>{i18n.t('screens.login.links.cookies')}</LinkText>
      </UsefullLink>
      <UsefullLink onPress={() => Linking.openURL(LINKS.confidentiality.replace('{{lang}}', i18n.lang))}>
        <LinkText alignTextLeft={alignTextLeft}>{i18n.t('screens.login.links.confidentiality')}</LinkText>
      </UsefullLink>
      <UsefullLink onPress={() => Linking.openURL(LINKS.who.replace('{{lang}}', i18n.lang))}>
        <LinkText alignTextLeft={alignTextLeft}>{i18n.t('screens.login.links.who')}</LinkText>
      </UsefullLink>
      <UsefullLink onPress={() => Linking.openURL(LINKS.legal.replace('{{lang}}', i18n.lang))}>
        <LinkText alignTextLeft={alignTextLeft}>{i18n.t('screens.login.links.legal')}</LinkText>
      </UsefullLink>
    </>
  )
}

export default CGU

const UsefullLink = styled(TouchableOpacity)`
  padding: 4px 0;
`

const LinkText = styled(Text)<{ alignTextLeft: boolean }>`
  text-decoration: underline;
  ${(props) => props.theme.fonts.Footnote};
  color: ${(props) =>
    props.theme.breakpoint === 'phone' && !props.alignTextLeft
      ? props.theme.colors.background
      : props.theme.colors.primary};
  text-decoration-color: ${(props) =>
    props.theme.breakpoint === 'phone' && !props.alignTextLeft
      ? props.theme.colors.background
      : props.theme.colors.primary};

  ${(props) => props.theme.breakpoint === 'phone' && !props.alignTextLeft && `text-align: center;`}
`
